import React from "react"
import PropTypes from "prop-types"
import SEO from "components/molecules/SEO"
import Layout from "components/molecules/Layout"
import { Information } from "components/molecules/PublicInformation"
import Legals from "components/molecules/Legals"

const TERMS_TOPICS = [
  "termsAndConditions",
  "disclaimer",
  "trademarksAndCopyrights",
  "linksTo",
  "linksFrom",
  "transmissions",
  "jurisdictionAndGoverningLaw",
  "limitation",
  "waiver",
  "integrationAndSeverability",
]

const TermsPage = ({ pageContext: { language } }) => (
  <Layout language={language}>
    <SEO title="Terms and Conditions" />
    <Information>
      <h1>Website terms</h1>
      <p>
        This website provides general company and property information. Private
        offering terms, eligibility and disclosures are supplied separately
        through the applicable offering process. The website does not establish
        investor qualification or a pre-existing substantive relationship.
      </p>
    </Information>
    <Legals topics={TERMS_TOPICS} pageType="terms" />
  </Layout>
)

TermsPage.propTypes = {
  pageContext: PropTypes.shape({
    language: PropTypes.string,
  }).isRequired,
}

export default TermsPage
